import { render } from "./Trips.vue?vue&type=template&id=3437ee37&scoped=true"
import script from "./Trips.vue?vue&type=script&lang=js"
export * from "./Trips.vue?vue&type=script&lang=js"

import "./Trips.vue?vue&type=style&index=0&id=3437ee37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3437ee37"]])

export default __exports__